const Logout=()=>{
    return <>
    You have successfully logged out!
    </>
}

export default Logout;